import {all, fork, put, takeLatest} from "redux-saga/effects";
import {AUTH, LOGIN, RESTORE, SIGN_UP} from "../reducers/profile/types";
import {checkedAuth, setErrorProfile, setFetchingProfile, setUser} from "../reducers/profile/actions";
import {loginFetch, me, restorePasswordFetch, signUpFetch} from "../api";

export function* authSaga() {
    yield takeLatest(AUTH, function* () {
        try {
            const access_token = yield localStorage.getItem('token');
            if (access_token) {
                const rs = yield me({access_token:access_token});
                if (rs.data.access_token) {
                    yield put(setUser({moderator: rs.data}));
                    yield localStorage.setItem('token', rs.data.moderator.access_token);
                }
            } else {
                yield put(checkedAuth());
            }
        } catch (e) {
            yield put(checkedAuth());
        }
    })
}

export function* loginSaga() {
    yield takeLatest(LOGIN, function* ({payload}) {
        yield put(setFetchingProfile(true));
        try {
            const rs = yield loginFetch(payload.data);
            if (payload.successCB) payload.successCB();
            if (rs.data.moderator.access_token) {
                localStorage.setItem('token', rs.data.moderator.access_token);
            }
            yield put(setUser(rs.data));
        } catch (e) {
            yield put(setErrorProfile(true));
            if (payload.errorCB) payload.errorCB();
        }
        yield put(setFetchingProfile(false));
        if (payload.finallyCB) payload.finallyCB();
    })
}

export function* signUpSaga() {
    yield takeLatest(SIGN_UP, function* ({payload}) {
        yield put(setFetchingProfile(true));
        try {
            const rs = yield signUpFetch(payload.data);
            if (payload.successCB) payload.successCB();
        } catch (e) {
            yield put(setErrorProfile(true));
            if (payload.errorCB) payload.errorCB();
        }
        yield put(setFetchingProfile(false));
        if (payload.finallyCB) payload.finallyCB();
    })
}

export function* restorePass() {
    yield takeLatest(RESTORE, function* ({payload}) {
        yield put(setFetchingProfile(true));
        try {
            const rs = yield restorePasswordFetch(payload.data);
            if (payload.successCB) payload.successCB();
        } catch (e) {
            yield put(setErrorProfile(true));
            if (payload.errorCB) payload.errorCB();
        }
        yield put(setFetchingProfile(false));
        if (payload.finallyCB) payload.finallyCB();
    })
}

function* profileSaga() {
    yield all([
        fork(loginSaga),
        fork(signUpSaga),
        fork(restorePass),
        fork(authSaga),
    ])
}

export default profileSaga;
